const _excluded = ["items", "separator", "collapsedItemsAriaLabel", "renderItem"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import ChevronRight from "@bolteu/kalep-react-icons/dist/ChevronRight";
import MoreIos from "@bolteu/kalep-react-icons/dist/MoreIos";
import { Menu, MenuItem } from "../Menu";
import { cx } from "../../helpers/utils/cx";
const ITEMS_BEFORE_COLLAPSE = 1;
const ITEMS_AFTER_COLLAPSE = 2;
export const DEFAULT_COLLAPSED_ITEMS_ARIA_LABEL = "Expanded breadcrumbs menu button";
const splitBreadcrumbItems = items => {
  const visibleItems = [...items]; // Make a copy of the array to safely splice
  const collapsedItems = visibleItems.splice(ITEMS_BEFORE_COLLAPSE, Math.max(items.length - ITEMS_AFTER_COLLAPSE - 1, 0));
  return {
    visibleItems,
    collapsedItems
  };
};
function SeparatorItem(_ref) {
  let {
    separator
  } = _ref;
  // context for the [&>svg]:block thing below: https://taxify.slack.com/archives/C030WAFUZBQ/p1674208953062119
  return /*#__PURE__*/React.createElement("li", {
    "aria-hidden": true,
    className: cx("[&>svg]:block")
  }, separator ?? /*#__PURE__*/React.createElement(ChevronRight, {
    className: cx("text-tertiary rtl:rotate-180"),
    size: "xs"
  }));
}
function CollapsedMenu(_ref2) {
  let {
    items,
    separator,
    collapsedItemsAriaLabel = DEFAULT_COLLAPSED_ITEMS_ARIA_LABEL
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Menu, {
    menuButton: /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: cx("block bg-transparent border-none p-0 text-link-primary hover:text-active-link-primary cursor-pointer"),
      "aria-label": collapsedItemsAriaLabel
    }, /*#__PURE__*/React.createElement(MoreIos, {
      size: "xs",
      className: cx("block")
    }))
  }, items.map((item, index) => /*#__PURE__*/React.createElement(MenuItem, {
    label: item.title,
    href: item.href,
    target: item.target,
    key: item.href ?? index
  })))), /*#__PURE__*/React.createElement(SeparatorItem, {
    separator: separator
  }));
}
function BreadcrumbItem(_ref3) {
  let {
    title,
    href,
    target = "_self",
    onClick,
    isCurrent,
    separator
  } = _ref3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: cx("bolt-font-body-s-regular")
  }, isCurrent ? /*#__PURE__*/React.createElement("span", {
    className: cx("text-primary")
  }, title) : /*#__PURE__*/React.createElement("a", {
    href: href,
    target: href ? target : undefined,
    onClick: onClick,
    className: cx("no-underline text-link-primary hover:text-active-link-primary cursor-pointer")
  }, title)), !isCurrent && /*#__PURE__*/React.createElement(SeparatorItem, {
    separator: separator
  }));
}
export function Breadcrumb(_ref4) {
  let {
      items,
      separator,
      collapsedItemsAriaLabel,
      renderItem
    } = _ref4,
    rest = _objectWithoutProperties(_ref4, _excluded);
  const {
    visibleItems,
    collapsedItems
  } = splitBreadcrumbItems(items);
  const hasCustomRenderer = typeof renderItem === "function";
  const itemsToUse = hasCustomRenderer ? items : visibleItems;
  return /*#__PURE__*/React.createElement("nav", rest, /*#__PURE__*/React.createElement("ol", {
    className: cx("list-none m-0 p-0", "flex gap-1 items-center flex-wrap")
  }, itemsToUse.map((item, index) => {
    const isCurrent = index === itemsToUse.length - 1;
    const fragmentKey = `${index}${item.href}`; // guards against several items with "" as href.

    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: fragmentKey
    }, hasCustomRenderer ? /*#__PURE__*/React.createElement(React.Fragment, null, renderItem(item), !isCurrent && /*#__PURE__*/React.createElement(SeparatorItem, {
      separator: separator
    })) : /*#__PURE__*/React.createElement(BreadcrumbItem, {
      title: item.title,
      href: item.href,
      target: item.target,
      onClick: item.onClick,
      isCurrent: isCurrent,
      separator: separator
    }), index === 0 && collapsedItems.length && !hasCustomRenderer ? /*#__PURE__*/React.createElement(CollapsedMenu, {
      items: collapsedItems,
      collapsedItemsAriaLabel: collapsedItemsAriaLabel
    }) : null);
  })));
}